import React from "react";
import { Link, useParams } from "react-router-dom";
import { getTranslationById } from "slices/translationSlice";
import { markTranslationCompleted } from "slices/translationSlice";
import { useDispatch } from "react-redux";
import { usePermissions } from "layouts/Admin";
import moment from "moment";
import { SubmitButton } from "components/common/buttons/SubmitButton";
import LogsTable from "views/appointment/view/LogsTable";
import TranslationViewTable from "./TranslationViewTable";
import { getTransLogs } from "slices/translationSlice";
import TransLogsTable from "./TransLogsTable";
import FullPageLoader from "components/common/FullPageLoader";
import QuotationsTable from "./QuotationsTable";
import { approveQuote } from "slices/translationSlice";
import { rejectQuote } from "slices/translationSlice";
import Swal from "sweetalert2";
import { ViewQuotationModal } from "./ViewQuotationModal";
import SelectTranslatorModal from "components/common/SelectTranslatorModal";
import { assignTranslators } from "slices/inviteTranslatorSlice";
import toast from "react-hot-toast";
import { translationApproveSubmission } from "slices/inviteTranslatorSlice";
import { translationMarkInvoiceAsPaid } from "slices/inviteTranslatorSlice";
import { translationCancel } from "slices/inviteTranslatorSlice";
import CancelModal from "components/appointment/CancelModal";
import UploadDocument from "components/appointment/UploadDocument";
import { translationUploadDocument } from "slices/inviteTranslatorSlice";
import TranslatedDocumentsTable from "./TranslatedDocumentsTable";
import InvoiceTable from "./InvoiceTable";
import CotationPopup from "./CotationPopup";
import { useNavigate } from "react-router-dom";
import MarkTranslationCompletedModal from "./MarkTranslationCompletedModal";
import { useTranslation } from 'react-i18next';

const TranslationView = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const { checkPermission } = usePermissions();
  const dispatch = useDispatch();
  const [item, setItem] = React.useState({});
  const [parentItem, setParentItem] = React.useState({});
  const [selectedProjectId, setSelectedProjectId] = React.useState(null);
  const [currentProjectId, setCurrentProjectId] = React.useState(id);
  const [loading, setLoading] = React.useState(false);
  const [logs, setLogs] = React.useState([]);
  const [assignTranslator, setAssignTranslator] = React.useState(false);
  const navigate = useNavigate();
  const [uploadDocumentTranslator, setUploadDocumentTranslator] =
    React.useState(false);

  const [invoiceSentTranslator, setInvoiceSentTranslator] =
    React.useState(false);

  const [cancelTranslator, setCancelTranslator] = React.useState(false);
  const [markCompletedModal, setMarkCompletedModal] = React.useState(false);
  const [quotationView, setQuotationView] = React.useState({
    show: false,
    id: null,
  });

  const callViewApi = async (projectId = id) => {
    const callBack = (success, data) => {
      setLoading(false);
      if (success) {
        // The backend always returns the true parent as the root object.
        // `current_project` is the freshly-loaded record for the viewed tab.
        setParentItem(data);

        const currentProject = data?.current_project || data;
        setItem(currentProject);

        // Auto-select the child tab when directly opening a child URL.
        // If current_project.id !== root id → we are viewing a child.
        setSelectedProjectId(
          currentProject?.id && String(currentProject.id) !== String(data?.id)
            ? currentProject.id
            : null
        );
console.log("testing call view api 1 currentProject?.id: " + currentProject?.id + " data?.id: " + data?.id + " projectId: " + projectId);
        setCurrentProjectId(currentProject?.id ?? data?.id ?? projectId);
      } else {
        setParentItem({});
        setItem({});
        setSelectedProjectId(null);
        console.log("testing call view api 2 id: " + id);
        setCurrentProjectId(id);
      }
    };
    dispatch(getTranslationById(projectId, callBack));
  };

  const selectProject = (project) => {
    // Determine whether the clicked project is the parent or a child.
    const isParent = String(project?.id) === String(parentItem?.id);
    // Always make a fresh API call with the clicked project's ID.
    // Pass the parent ID when clicking the parent tab so the backend
    // knows to return the parent as both root AND current_project.
    setLoading(true);
    callViewApi(isParent ? parentItem.id : project.id);
  };

  //   fetch logs
  const fetchLogs = async () => {
    const callBack = (success, message, data) => {
      if (success) {
        setLogs(data);
      } else {
        console.log("res", message);
      }
    };
    // dispatch(getTransLogs(id, callBack));
    dispatch(getTransLogs(currentProjectId, callBack));
  };

  React.useEffect(() => {
    console.log("testing id: " + id);
    if (id) {
      console.log("testing id2: " + id);
      setLoading(true);
      callViewApi();
      // fetchLogs();
    }
  }, [id]);

  // React.useEffect(() => {
  //   if (id && (selectedProjectId || item?.id)) {
  //     fetchLogs();
  //   }
  // }, [id, selectedProjectId, item?.id]);
  React.useEffect(() => {
    console.log("testing currentProjectId: " + currentProjectId);
    if (currentProjectId) {
      console.log("testing currentProjectId2: " + currentProjectId);
      fetchLogs();
    }
  }, [currentProjectId]);

  const mileageCheck = (val) => {
    return item?.appointment_details?.[val];
  };

  const rawDatetime = item?.created_at;

  const onApprove = () => {
    Swal.fire({
      title: t('translationView.confirmation'),
      text: t('translationView.approveConfirmation'),
      confirmButtonText: t('accountForm.yes'),
      cancelButtonText: t('accountForm.no'),
      showCancelButton: true,
      customClass: {
                cancelButton: 'main_button  tomatoRed',
                confirmButton: 'swal-btn',
            },
    }).then(({ isConfirmed }) => {
      if (isConfirmed) {
        setLoading(true);
        const callBack = (success) => {
          if (success) {
            toast.success(t('translationView.approvedSuccessfully'), {
              className: "successToast",
            });
            // const listCallBack = (success, data) => {
            //   setLoading(false);
            //   if (success) {
            //     setItem(data);
            //   } else {
            //     setItem({});
            //   }
            // };
            // dispatch(getTranslationById(item?.id, listCallBack));
            // callViewApi(selectedProjectId || id);
            callViewApi(currentProjectId);

            setLoading(false);
          } else {
          }
        };
        dispatch(approveQuote(item?.id, callBack));
      }
    });
  };

  const onReject = () => {
    Swal.fire({
      title: t('translationView.rejectionReason'),
      // text: "Are you sure, you want to reject it?",
      confirmButtonText: t('translation.submit'),
      cancelButtonText: t('billing.cancel'),
      showCancelButton: true,
      input: "text",
      customClass: {
                cancelButton: 'main_button  tomatoRed',
                confirmButton: 'swal-btn',
                input: "input-in type_inp",
            },
      inputPlaceholder: t('translationView.rejectionPlaceholder'),
      inputValidator: (value) => {
        if (!value) {
          return t('translationView.rejectionRequired');
        }
      },
    }).then(({ isConfirmed, value }) => {
      if (isConfirmed) {
        const callBack = (success) => {
          if (success) {
            toast.success(t('translationView.rejectedSuccessfully'), {
              className: "successToast",
            });
            // const listCallBack = (success, data) => {
            //   setLoading(false);
            //   if (success) {
            //     setItem(data);
            //   } else {
            //     setItem({});
            //   }
            // };
            // dispatch(getTranslationById(item?.id, listCallBack));
            // callViewApi(selectedProjectId || id);
            callViewApi(currentProjectId);

            setLoading(false);
          }
        };
        const data = {
          rejection_reason: value,
        };
        setLoading(true);
        dispatch(rejectQuote(item?.id, data, callBack));
      }
    });
  };

  const formattedDate = moment(rawDatetime, "YYYY-MM-DD HH:mm:ss").format(
    "MMM D, YYYY HH:mm:ss"
  );

  const [cotationPopup, setCotationPopup] = React.useState({
    open: false,
    documents: [],
  });

  const openQuotationView = (qId) =>
    setQuotationView({
      show: true,
      id: qId,
    });

  const handleEditTranslation = () => {
    navigate("/translation/edit/" + item?.id);
  };

  const handleCopyTranslation = () => {
    navigate("/translation/copy/" + item?.id);
  };

  const isReassign = !!item?.interpreter_id;

  const handleAssignTranslator = () => {
    setAssignTranslator(true);
  };
  const handleCloseAssignTranslator = () => {
    setAssignTranslator(false);
  };
  const handleUploadDocumentTranslator = () => {
    setUploadDocumentTranslator(true);
  };
  const handleCloseUploadDocumentTranslator = () => {
    setUploadDocumentTranslator(false);
  };

  const handleCancelTranslator = () => {
    setCancelTranslator(true);
  };
  const handleCloseCancelTranslator = () => {
    setCancelTranslator(false);
  };

  const handleMarkCompleted = (data) => {
    setLoading(true);
    const clientId = item?.client_id || item?.account_id || item?.accounts?.id;
    const callback = (success, message) => {
      if (success) {
        toast.success(message || t('translationView.statusUpdated'), {
          className: "successToast",
        });
        setMarkCompletedModal(false);
        // callViewApi(selectedProjectId || id);
        callViewApi(currentProjectId);
      } else {
        toast.error(message || t('translationView.statusUpdateFailed'), {
          className: "errorToast",
        });
      }
      setLoading(false);
    };

    dispatch(markTranslationCompleted(item?.id, { ...data, client_id: clientId }, callback));
  };

  const onAssign = (iterp_id, isReassignFlag) => {
    setLoading(true);
    const payload = {
      interpreter_id: iterp_id,
    };
    const callBack = (success) => {
      if (success) {
        toast.success(isReassignFlag ? t('translationView.reassignedSuccessfully') : t('translationView.assignedSuccessfully'), {
          className: "successToast",
        });

        // callViewApi(selectedProjectId || id);
        callViewApi(currentProjectId);
        handleCloseAssignTranslator();
      } else {
        toast.error(isReassignFlag ? t('translationView.reassignFailed') : t('translationView.assignFailed'), {
          className: "errorToast",
        });
      }
      setLoading(false);
    };
    dispatch(assignTranslators(payload, item?.id || id, callBack, isReassignFlag));
  };

  const onApproveSubmmision = () => {
    Swal.fire({
      title: t('translationView.confirmation'),
      text: t('translationView.approveSubmissionConfirmation'),
      confirmButtonText: t('accountForm.yes'),
      cancelButtonText: t('accountForm.no'),
      showCancelButton: true,
      customClass: {
                cancelButton: 'main_button tomatoRed',
                confirmButton: 'swal-btn',
            },
    }).then(({ isConfirmed }) => {
      if (isConfirmed) {
        setLoading(true);
        const callBack = (success) => {
          if (success) {
            toast.success(t('translationView.approvedSubmissionSuccessfully'), {
              className: "successToast",
            });
            // callViewApi(selectedProjectId || id);
            callViewApi(currentProjectId);

            setLoading(false);
          } else {
            setLoading(false);
          }
        };
        dispatch(translationApproveSubmission(item?.id || id, callBack));
      }
    });
  };

  const onMarkInvoiceAsPaid = () => {
    Swal.fire({
      title: t('translationView.confirmation'),
      text: t('translationView.markInvoicePaidConfirmation'),
      confirmButtonText: t('accountForm.yes'),
      cancelButtonText: t('accountForm.no'),
      showCancelButton: true,
      customClass: {
                cancelButton: 'main_button tomatoRed',
                confirmButton: 'swal-btn',
            },
    }).then(({ isConfirmed }) => {
      if (isConfirmed) {
        setLoading(true);
        const callBack = (success) => {
          if (success) {
            toast.success(t('translationView.invoiceMarkedPaid'), {
              className: "successToast",
            });
            // callViewApi(selectedProjectId || id);
            callViewApi(currentProjectId);
            setLoading(false);
          } else {
            setLoading(false);
          }
        };
        dispatch(translationMarkInvoiceAsPaid(item?.id || id, callBack));
      }
    });
  };

  
  const onCancelTranslation = (data) => {
    const callBack = (success) => {
      if (success) {
        toast.success(t('translationView.cancelledSuccessfully'), {
          className: "successToast",
        });

        // callViewApi(selectedProjectId || id);
        callViewApi(currentProjectId);
        handleCloseCancelTranslator();
      } else {
      }
    };
    dispatch(translationCancel(data, item?.id || id, callBack));
  };
  // const onUploadDocument = (data) => {
  //   const callBack = (success) => {
  //     if (success) {
  //       toast.success("Uploaded Successfully", {
  //         className: "successToast",
  //       });
  //       callViewApi();
  //       handleCloseUploadDocumentTranslator();
  //     } else {
  //     }
  //   };
  //   const formdata = new FormData();
  //   formdata.append("file", data);
  //   dispatch(translationUploadDocument(formdata, id, callBack));
  // };
  const onUploadDocument = (data) => {
    setLoading(true);
    const callBack = (success) => {
      setLoading(false);
      if (success) {
        toast.success(t('translationView.uploadedSuccessfully'), {
          className: "successToast",
        });
        // callViewApi(selectedProjectId || id);
        callViewApi(currentProjectId);
        handleCloseUploadDocumentTranslator();
      } else {
        toast.error(t('translationView.uploadFailed'));
      }
    };

    const formdata = new FormData();
    formdata.append("file", data);
    dispatch(translationUploadDocument(formdata, item?.id || id, callBack));
  };

  return (
    <div className="content" style={{}}>
      {quotationView.show && (
        <ViewQuotationModal
          itemId={quotationView?.id}
          item={item}
          show={quotationView.show}
          onClose={() => setQuotationView({ show: false, id: null })}
        />
      )}

      <SelectTranslatorModal
        isOpen={assignTranslator}
        onClose={handleCloseAssignTranslator}
        onConfirm={onAssign}
        appointmentId={id}
        item={item}
        loader={loading}
        isReassign={isReassign}
      />

      <CancelModal
        isOpen={cancelTranslator}
        onClose={handleCloseCancelTranslator}
        onConfirm={onCancelTranslation}
        appointmentId={id}
        item={item}
        loader={loading}
          heading={t('translationView.project')}
        showAppId={false}
      />

      <UploadDocument
        isOpen={uploadDocumentTranslator}
        onClose={handleCloseUploadDocumentTranslator}
        onConfirm={onUploadDocument}
        appointmentId={id}
        item={item}
        loader={loading}
      />

      <MarkTranslationCompletedModal
        isOpen={markCompletedModal}
        onClose={() => setMarkCompletedModal(false)}
        onConfirm={handleMarkCompleted}
        loader={loading}
      />

      <CotationPopup
        callViewApi={callViewApi}
        open={cotationPopup.open}
        onClose={() => setCotationPopup({ open: false, documents: [] })}
        documents={cotationPopup.documents}
        transId={id}
        item={item}
      />

      {loading && <FullPageLoader />}
      {/* {parentItem?.parent_project_links?.length > 0 && (
        <div className="row-primary flex-wrap mb-3" role="tablist" aria-label="Linked project phases">
          <SubmitButton
            buttonType="button"
            className={!selectedProjectId ? "main_button" : "lightGrey"}
            // btnText="Parent"
            btnText={
              parentItem?.translation_details?.current_phase
                ? parentItem.translation_details.current_phase
                    .replace(/_/g, " ")
                    .replace(/\b\w/g, (letter) => letter.toUpperCase())
                : "Parent"
            }
            handleSubmit={() => selectProject(parentItem)}
          />
          {parentItem.parent_project_links.map((link) => {
            const child = link?.child_translation;
            const phase = child?.translation_details?.current_phase;
            if (!child || !phase) return null;
            const phaseLabel = phase
              .replace(/_/g, " ")
              .replace(/\b\w/g, (letter) => letter.toUpperCase());
            return (
              <SubmitButton
                key={child.id}
                buttonType="button"
                data-project-id={child.id}
                className={String(selectedProjectId) === String(child.id) ? "main_button" : "lightGrey"}
                btnText={phaseLabel}
                handleSubmit={() => selectProject(child)}
              />
            );
          })}
        </div>
      )} */}
      <div className="row_main_head bg-primary-secondaryCard">
        <h2 className={`main_heading main_heading1 mb-3`}>
          {t('translationView.projectJob')} #{item?.transid}
        </h2>
        <h2 className={`main_heading main_heading1 mb-3`}>
          {t('translationView.client')}: #{item?.accounts?.user?.name || t('common.nA')}
        </h2>
      </div>
      <div className="row_main_head bg-light-secondaryCard mt-3">
        <h2 className={`main_heading2 translation viewpage`} toLowerCase={"text-lowercase"}>
          {t('translationView.dateTime')} <span className="dateTime">{formattedDate}</span>
        </h2>

        <div className="mb-3 row_check">
          <div className="text-transform-capitalize main_heading2">
            <span className="appLanguage">{item?.status}</span>
          </div>
        </div>
      </div>
      {parentItem?.parent_project_links?.length > 0 && (
        <div className="translation-tab-div" role="tablist" aria-label="Linked project phases">
          <SubmitButton
            buttonType="button"
            className={!selectedProjectId ? "active main_button" : "lightGrey"}
            // btnText="Parent"
            btnText={
              parentItem?.translation_details?.current_phase
                ? parentItem.translation_details.current_phase
                    .replace(/_/g, " ")
                    .replace(/\b\w/g, (letter) => letter.toUpperCase())
                : "Parent"
            }
            handleSubmit={() => selectProject(parentItem)}
          />
          {parentItem.parent_project_links.map((link) => {
            const child = link?.child_translation;
            const phase = child?.translation_details?.current_phase;
            if (!child || !phase) return null;
            const phaseLabel = phase
              .replace(/_/g, " ")
              .replace(/\b\w/g, (letter) => letter.toUpperCase());
            return (
              <SubmitButton
                key={child.id}
                buttonType="button"
                className={String(selectedProjectId) === String(child.id) ? "active main_button" : "lightGrey"}
                btnText={phaseLabel}
                handleSubmit={() => selectProject(child)}
              />
            );
          })}
        </div>
      )}
      <div className={ parentItem?.parent_project_links?.length > 0 ? "translation-detail card_table view_table_custom" : "card_table view_table_custom" }>
        <div className="row-primary flex-wrap justify-content-between">
          <div className="row-primary flex-wrap">
            {checkPermission("Copy Appointment") && (
              <SubmitButton
                buttonType="button"
                className={"lightPurple"}
                btnText={t('appointmentView.copy')}
                handleSubmit={handleCopyTranslation}
              />
            )}
            {(item?.status === "Translators Invited" ||
              // item?.status === "Cancelled" ||
              item?.status === "Translator Declined" ||
              item?.status === "Assigned" ||
              item?.status === "Quote Approved") &&
              checkPermission('Assign Translations') && (
              <SubmitButton
                buttonType="button"
                className={"green"}
                btnText={isReassign ? t('translationView.reassign') : t('translationView.assign')}
                style={{ fontSize: "14px" }}
                handleSubmit={handleAssignTranslator}
              />
            )}
            {checkPermission("Edit Appointments") && item?.status != "Completed" && item?.status != "Cancelled" && (
              <SubmitButton
                buttonType="button"
                className={"lightGrey"}
                btnText={t('vendors.edit')}
                handleSubmit={handleEditTranslation}
              />
            )}
            {item?.status !== "Completed" && item?.status == "Under Review" && (
              <SubmitButton
                buttonType="button"
                className={"main_button  Cancle_button"}
                btnText={t('translationView.markCompleted')}
                handleSubmit={() => setMarkCompletedModal(true)}
              />
            )}
            {/* {item.status == 'Under Review' &&
              <SubmitButton
                buttonType="button"
                className={"green"}
                btnText="Assign"
                handleSubmit={handleAssignTranslator}
              />
            )}
            {item.status !== "Completed" && (
              <SubmitButton
                buttonType="button"
                className={"tomatoRed"}
                btnText="Cancel"
                handleSubmit={handleCancelTranslator}
              />
            )}
            {item.status == "Assigned" && (
            } */}
            {item.status !== "Completed" &&
              item.status !== "Cancelled" &&
              item.status !== "Client Cancelled" && 
              checkPermission('Cancel Translations') && (
                <SubmitButton
                  buttonType="button"
                  className={"tomatoRed"}
                  btnText={t('translationView.cancelProject')}
                  style={{ fontSize: "14px" }}
                  handleSubmit={handleCancelTranslator}
                />
              )}
            {(item.status == "Assigned" ||
              item.status == "Submission Rejected") &&
              checkPermission('Upload Translated Documents') && (
              <SubmitButton
                buttonType="button"
                className={"green"}
                btnText={t('translationView.uploadTranslatedDocuments')}
                style={{ fontSize: "14px" }}
                handleSubmit={handleUploadDocumentTranslator}
              />
            )}
          </div>
        </div>

        {mileageCheck("extra_mileage") &&
        mileageCheck("extra_mileage_request") == null ? (
          <div className="row_main_head align-items-center softAlert waiting">
            <h3>{t('appointmentView.extraMileageRequested')}</h3>
            {checkPermission("Extra Mileage") && (
              <SubmitButton
                buttonType="button"
                className={"green"}
                btnText={t('appointmentView.viewRequest')}
                style={{ fontSize: "14px" }}
              />
            )}
          </div>
        ) : mileageCheck("extra_mileage") &&
          mileageCheck("extra_mileage_request") == 1 ? (
          <div className="softAlert approved">
            <h3>
              {t('appointmentView.extraMileageApproved')}
            </h3>
          </div>
        ) : mileageCheck("extra_mileage") &&
          mileageCheck("extra_mileage_request") == 0 ? (
          <div className="softAlert rejected">
            <h3>
              {t('appointmentView.extraMileageRejected')}
            </h3>
          </div>
        ) : (
          ""
        )}
        <TranslationViewTable item={item} />

        {item?.quotations && item?.quotations[0]?.approved == 1 && item?.status != "Assigned" && item?.status != "Under Review" && item?.status != "Completed" && checkPermission('Invite Translators') && (
          <Link
            to={`/translation/invite-translators/${item?.id}`}
            type="button"
            className="main_button"
          >
            {t('translationView.inviteTranslators')}
          </Link>
        )}
      </div>

      {/* {item && item?.translation_invoices && (
        <>
          <div className="card_table p-4">
            <div className="row_main_head mb-3">
              <h2 className={`main_heading`}>Invoice</h2>
            </div>
            <InvoiceTable
              item={item}
              onMarkInvoiceAsPaid={onMarkInvoiceAsPaid}
            />
          </div>
        </>
      )} */}

      {item && item?.translation_translated_files?.length > 0 && (
        <>
          <div className="card_table p-4">
            <div className="row_main_head mb-3">
              <h2 className={`main_heading`}>{t('translationView.translatedDocuments')}</h2>
            </div>
            <TranslatedDocumentsTable
              item={item}
              onApproveSubmmision={onApproveSubmmision}
              callViewApi={callViewApi}
            />
          </div>
        </>
      )}

      {/* {item?.translation_files?.length > 0 && ( */}
      <div className="card_table p-4">
        <div className="row_main_head mb-3">
          <h2 className={`main_heading`}>{t('translationView.originalDocuments')}</h2>
        </div>
        {console.log(item, 'asdqwasd')}
        <TransLogsTable item={item} />
      </div>
      {/* )} */}

      <div className="card_table p-4">
        <div className="row_main_head mb-3">
          <h2 className={`main_heading`}>{t('translationView.quotationsHistory')}</h2>
          {(checkPermission('Revise Quotations')) && item?.status != "Quote Approved"  && item?.status != "Completed" && (
          <SubmitButton
            handleSubmit={() => setCotationPopup({ open: true, documents: [] })}
            btnText={t('translationView.reviseQuote')}
            className="main_button"
          />
          )}
        </div>

        {/* Quotation Tables  */}
        <QuotationsTable
          item={item}
          onApprove={onApprove}
          onReject={onReject}
          onView={openQuotationView}
        />
      </div>

      <div className="card_table p-4">
        <div className="row_main_head mb-3">
          <h2 className={`main_heading`}>{t('translationView.projectLogs')}</h2>
        </div>
        <LogsTable logs={logs} />
      </div>
    </div>
  );
};

export default TranslationView;
